import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center md:bg-background sm:bg-white" }
const _hoisted_2 = { class: "flex flex-col bg-white sm:shadow-sm md:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 md:rounded-2xl w-full max-w-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-1/2 mb-8"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "txt-card-title mb-8" }, "Log in to Axelerate", -1)
const _hoisted_5 = {
  key: 0,
  class: "bg-error text-white rounded flex flex-col items-center p-4 -mt-4 mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Login failed", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Please double-check your email and password and try again. ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "mt-8" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row items-center justify-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Logging in...", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Log in", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-row items-center justify-end mt-4 mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-3" }, "Don't have an account yet?")
], -1)
const _hoisted_18 = { class: "flex flex-wrap justify-center" }
const _hoisted_19 = { class: "h-full p-2 lg:w-1/2" }
const _hoisted_20 = { class: "h-full p-2 lg:w-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.loginError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_TextField, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            name: "email",
            label: "Email",
            error: _ctx.fieldErrors.email,
            isError: _ctx.loginError
          }, null, 8, ["modelValue", "error", "isError"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_TextField, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            typeInput: "password",
            name: "password",
            label: "Password",
            error: _ctx.fieldErrors.password,
            isError: _ctx.loginError
          }, null, 8, ["modelValue", "error", "isError"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "submit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
            class: _normalizeClass(["mt-4 w-full", {
              'btn-filled-lg-loading': _ctx.isLoading,
              'btn-filled-lg': !_ctx.isLoading,
            }])
          }, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Spinner, {
                    color: "white",
                    height: "6",
                    width: "6",
                    border: "2"
                  }),
                  _hoisted_12
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          ], 2)
        ])
      ], 32),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/forgot-password'))),
          class: "btn-text"
        }, " Forgot password? ")
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/sign-up/talent'))),
            class: "btn-text"
          }, " Sign up for talent ")
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/sign-up/businesses'))),
            class: "btn-text"
          }, " Sign up for businesses ")
        ])
      ])
    ])
  ]))
}